//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

export const DEFAULT_PAGE_SIZE = 8;
export const DEFAULT_PAGE_NUMBER = 0;
export const DEFAULT_ITEMS_PER_PAGE_OPTIONS = [8, 16, 32, 64];
